"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MacroEmbedded = exports.SequenceBindingCheck = exports.SequenceBindingLetThe = exports.SequenceBindingLet = exports.SequenceUnfolded = exports.SequenceCheck = exports.SequenceLetThe = exports.SequenceLet = exports.Dot = exports.NewAp = exports.NewUnfolded = exports.New = exports.PropertySpread = exports.PropertyPlain = exports.ObjektUnfolded = exports.Objekt = exports.ClazzBindingFulfilled = exports.ClazzBindingAbstract = exports.ClazzUnfolded = exports.ClazzFulfilled = exports.ClazzCons = exports.ClazzNull = exports.Quote = exports.Cons = exports.SigmaBindingNamed = exports.SigmaBindingNameless = exports.SigmaUnfolded = exports.Sigma = exports.ArgImplicit = exports.ArgPlain = exports.ApUnfolded = exports.ApImplicit = exports.Ap = exports.FnBindingAnnotatedImplicit = exports.FnBindingImplicit = exports.FnBindingAnnotated = exports.FnBindingName = exports.FnUnfoldedWithRetType = exports.FnUnfolded = exports.FnImplicitAnnotated = exports.FnImplicit = exports.FnAnnotated = exports.Fn = exports.PiBindingImplicit = exports.PiBindingNamed = exports.PiBindingNameless = exports.PiUnfolded = exports.PiImplicit = exports.Pi = exports.Var = void 0;
function Var(name, span) {
    return {
        "@type": "Exp",
        "@kind": "Var",
        name,
        span,
    };
}
exports.Var = Var;
function Pi(name, argType, retType, span) {
    return {
        "@type": "Exp",
        "@kind": "Pi",
        name,
        argType,
        retType,
        span,
    };
}
exports.Pi = Pi;
function PiImplicit(name, argType, retType, span) {
    return {
        "@type": "Exp",
        "@kind": "PiImplicit",
        name,
        argType,
        retType,
        span,
    };
}
exports.PiImplicit = PiImplicit;
function PiUnfolded(bindings, retType, span) {
    return {
        "@type": "Exp",
        "@kind": "PiUnfolded",
        bindings,
        retType,
        span,
    };
}
exports.PiUnfolded = PiUnfolded;
function PiBindingNameless(type, span) {
    return {
        "@kind": "PiBindingNameless",
        type,
        span,
    };
}
exports.PiBindingNameless = PiBindingNameless;
function PiBindingNamed(name, type, span) {
    return {
        "@kind": "PiBindingNamed",
        name,
        type,
        span,
    };
}
exports.PiBindingNamed = PiBindingNamed;
function PiBindingImplicit(name, type, span) {
    return {
        "@kind": "PiBindingImplicit",
        name,
        type,
        span,
    };
}
exports.PiBindingImplicit = PiBindingImplicit;
function Fn(name, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "Fn",
        name,
        ret,
        span,
    };
}
exports.Fn = Fn;
function FnAnnotated(name, argType, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "FnAnnotated",
        name,
        argType,
        ret,
        span,
    };
}
exports.FnAnnotated = FnAnnotated;
function FnImplicit(name, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "FnImplicit",
        name,
        ret,
        span,
    };
}
exports.FnImplicit = FnImplicit;
function FnImplicitAnnotated(name, argType, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "FnImplicitAnnotated",
        name,
        argType,
        ret,
        span,
    };
}
exports.FnImplicitAnnotated = FnImplicitAnnotated;
function FnUnfolded(bindings, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "FnUnfolded",
        bindings,
        ret,
        span,
    };
}
exports.FnUnfolded = FnUnfolded;
function FnUnfoldedWithRetType(bindings, retType, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "FnUnfoldedWithRetType",
        bindings,
        retType,
        ret,
        span,
    };
}
exports.FnUnfoldedWithRetType = FnUnfoldedWithRetType;
function FnBindingName(name, span) {
    return {
        "@kind": "FnBindingName",
        name,
        span,
    };
}
exports.FnBindingName = FnBindingName;
function FnBindingAnnotated(name, type, span) {
    return {
        "@kind": "FnBindingAnnotated",
        name,
        type,
        span,
    };
}
exports.FnBindingAnnotated = FnBindingAnnotated;
function FnBindingImplicit(name, span) {
    return {
        "@kind": "FnBindingImplicit",
        name,
        span,
    };
}
exports.FnBindingImplicit = FnBindingImplicit;
function FnBindingAnnotatedImplicit(name, type, span) {
    return {
        "@kind": "FnBindingAnnotatedImplicit",
        name,
        type,
        span,
    };
}
exports.FnBindingAnnotatedImplicit = FnBindingAnnotatedImplicit;
function Ap(target, arg, span) {
    return {
        "@type": "Exp",
        "@kind": "Ap",
        target,
        arg,
        span,
    };
}
exports.Ap = Ap;
function ApImplicit(target, arg, span) {
    return {
        "@type": "Exp",
        "@kind": "ApImplicit",
        target,
        arg,
        span,
    };
}
exports.ApImplicit = ApImplicit;
function ApUnfolded(target, args, span) {
    return {
        "@type": "Exp",
        "@kind": "ApUnfolded",
        target,
        args,
        span,
    };
}
exports.ApUnfolded = ApUnfolded;
function ArgPlain(exp) {
    return {
        "@kind": "ArgPlain",
        exp,
    };
}
exports.ArgPlain = ArgPlain;
function ArgImplicit(exp) {
    return {
        "@kind": "ArgImplicit",
        exp,
    };
}
exports.ArgImplicit = ArgImplicit;
function Sigma(name, carType, cdrType, span) {
    return {
        "@type": "Exp",
        "@kind": "Sigma",
        name,
        carType,
        cdrType,
        span,
    };
}
exports.Sigma = Sigma;
function SigmaUnfolded(bindings, cdrType, span) {
    return {
        "@type": "Exp",
        "@kind": "SigmaUnfolded",
        bindings,
        cdrType,
        span,
    };
}
exports.SigmaUnfolded = SigmaUnfolded;
function SigmaBindingNameless(type, span) {
    return {
        "@kind": "SigmaBindingNameless",
        type,
        span,
    };
}
exports.SigmaBindingNameless = SigmaBindingNameless;
function SigmaBindingNamed(name, type, span) {
    return {
        "@kind": "SigmaBindingNamed",
        name,
        type,
        span,
    };
}
exports.SigmaBindingNamed = SigmaBindingNamed;
function Cons(car, cdr, span) {
    return {
        "@type": "Exp",
        "@kind": "Cons",
        car,
        cdr,
        span,
    };
}
exports.Cons = Cons;
function Quote(data, span) {
    return {
        "@type": "Exp",
        "@kind": "Quote",
        data,
        span,
    };
}
exports.Quote = Quote;
function ClazzNull(name, span) {
    return {
        "@type": "Exp",
        "@kind": "ClazzNull",
        name,
        span,
    };
}
exports.ClazzNull = ClazzNull;
function ClazzCons(propertyName, localName, propertyType, rest, name, span) {
    return {
        "@type": "Exp",
        "@kind": "ClazzCons",
        propertyName,
        localName,
        propertyType,
        rest,
        name,
        span,
    };
}
exports.ClazzCons = ClazzCons;
function ClazzFulfilled(propertyName, localName, propertyType, property, rest, name, span) {
    return {
        "@type": "Exp",
        "@kind": "ClazzFulfilled",
        propertyName,
        localName,
        propertyType,
        property,
        rest,
        name,
        span,
    };
}
exports.ClazzFulfilled = ClazzFulfilled;
function ClazzUnfolded(bindings, name, span) {
    return {
        "@type": "Exp",
        "@kind": "ClazzUnfolded",
        bindings,
        name,
        span,
    };
}
exports.ClazzUnfolded = ClazzUnfolded;
function ClazzBindingAbstract(name, propertyType) {
    return {
        "@kind": "ClazzBindingAbstract",
        name,
        propertyType,
    };
}
exports.ClazzBindingAbstract = ClazzBindingAbstract;
function ClazzBindingFulfilled(name, propertyType, property) {
    return {
        "@kind": "ClazzBindingFulfilled",
        name,
        propertyType,
        property,
    };
}
exports.ClazzBindingFulfilled = ClazzBindingFulfilled;
function Objekt(properties, span) {
    return {
        "@type": "Exp",
        "@kind": "Objekt",
        properties,
        span,
    };
}
exports.Objekt = Objekt;
function ObjektUnfolded(properties, span) {
    return {
        "@type": "Exp",
        "@kind": "ObjektUnfolded",
        properties,
        span,
    };
}
exports.ObjektUnfolded = ObjektUnfolded;
function PropertyPlain(name, exp) {
    return {
        "@kind": "PropertyPlain",
        name,
        exp,
    };
}
exports.PropertyPlain = PropertyPlain;
function PropertySpread(exp) {
    return {
        "@kind": "PropertySpread",
        exp,
    };
}
exports.PropertySpread = PropertySpread;
function New(name, properties, span) {
    return {
        "@type": "Exp",
        "@kind": "New",
        name,
        properties,
        span,
    };
}
exports.New = New;
function NewUnfolded(name, properties, span) {
    return {
        "@type": "Exp",
        "@kind": "NewUnfolded",
        name,
        properties,
        span,
    };
}
exports.NewUnfolded = NewUnfolded;
function NewAp(name, args, span) {
    return {
        "@type": "Exp",
        "@kind": "NewAp",
        name,
        args,
        span,
    };
}
exports.NewAp = NewAp;
function Dot(target, name, span) {
    return {
        "@type": "Exp",
        "@kind": "Dot",
        target,
        name,
        span,
    };
}
exports.Dot = Dot;
function SequenceLet(name, exp, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "SequenceLet",
        name,
        exp,
        ret,
        span,
    };
}
exports.SequenceLet = SequenceLet;
function SequenceLetThe(name, type, exp, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "SequenceLetThe",
        name,
        type,
        exp,
        ret,
        span,
    };
}
exports.SequenceLetThe = SequenceLetThe;
function SequenceCheck(exp, type, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "SequenceCheck",
        exp,
        type,
        ret,
        span,
    };
}
exports.SequenceCheck = SequenceCheck;
function SequenceUnfolded(bindings, ret, span) {
    return {
        "@type": "Exp",
        "@kind": "SequenceUnfolded",
        bindings,
        ret,
        span,
    };
}
exports.SequenceUnfolded = SequenceUnfolded;
function SequenceBindingLet(name, exp, span) {
    return {
        "@kind": "SequenceBindingLet",
        name,
        exp,
        span,
    };
}
exports.SequenceBindingLet = SequenceBindingLet;
function SequenceBindingLetThe(name, type, exp, span) {
    return {
        "@kind": "SequenceBindingLetThe",
        name,
        type,
        exp,
        span,
    };
}
exports.SequenceBindingLetThe = SequenceBindingLetThe;
function SequenceBindingCheck(exp, type, span) {
    return {
        "@kind": "SequenceBindingCheck",
        exp,
        type,
        span,
    };
}
exports.SequenceBindingCheck = SequenceBindingCheck;
function MacroEmbedded(macro, span) {
    return {
        "@type": "Exp",
        "@kind": "MacroEmbedded",
        macro,
        span,
    };
}
exports.MacroEmbedded = MacroEmbedded;
//# sourceMappingURL=Exp.js.map